var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobMatchesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.8932 8.68131C30.631 9.86813 31 11.4945 31 13.5604C31 15.5824 30.465 17.5165 29.3952 19.3626C28.3254 21.1648 26.942 22.7033 25.2451 23.978C21.7773 26.6593 17.8485 28 13.4585 28C9.21606 28 6.20948 26.7033 4.43873 24.1098C3.47958 22.6593 3 20.945 3 18.967C3 15.0549 4.67853 11.5824 8.03557 8.54945C11.3926 5.51649 15.3952 4 20.0435 4C24.7286 4 28.0118 5.56044 29.8932 8.68131Z",
    fill: "#FFC8B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6423 9.85882C12.6423 9.14874 13.2179 8.5731 13.928 8.5731H21.6423C22.3524 8.5731 22.928 9.14874 22.928 9.85882C22.928 10.5689 22.3524 11.1445 21.6423 11.1445H13.928C13.2179 11.1445 12.6423 10.5689 12.6423 9.85882Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.928 15.0017C13.2179 15.0017 12.6423 15.5773 12.6423 16.2874C12.6423 16.9975 13.2179 17.5731 13.928 17.5731H21.6423C22.3524 17.5731 22.928 16.9975 22.928 16.2874C22.928 15.5773 22.3524 15.0017 21.6423 15.0017H13.928Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6423 22.716C12.6423 22.0059 13.2179 21.4302 13.928 21.4302H21.6423C22.3524 21.4302 22.928 22.0059 22.928 22.716C22.928 23.426 22.3524 24.0017 21.6423 24.0017H13.928C13.2179 24.0017 12.6423 23.426 12.6423 22.716Z",
    fill: "#222222"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3566 9.85882C11.3566 10.5689 10.781 11.1445 10.0709 11.1445C9.36077 11.1445 8.78516 10.5689 8.78516 9.85882C8.78516 9.14872 9.36077 8.5731 10.0709 8.5731C10.781 8.5731 11.3566 9.14872 11.3566 9.85882Z",
    fill: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0709 17.5731C10.781 17.5731 11.3566 16.9975 11.3566 16.2874C11.3566 15.5773 10.781 15.0017 10.0709 15.0017C9.36077 15.0017 8.78516 15.5773 8.78516 16.2874C8.78516 16.9975 9.36077 17.5731 10.0709 17.5731Z",
    fill: "#222222"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3566 22.716C11.3566 23.4261 10.781 24.0017 10.0709 24.0017C9.36077 24.0017 8.78516 23.4261 8.78516 22.716C8.78516 22.0059 9.36077 21.4302 10.0709 21.4302C10.781 21.4302 11.3566 22.0059 11.3566 22.716Z",
    fill: "#222222"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28516 4.71596C4.28516 3.2958 5.43642 2.14453 6.85659 2.14453H24.8566C26.2767 2.14453 27.428 3.2958 27.428 4.71596V27.8588C27.428 29.279 26.2767 30.4302 24.8566 30.4302H6.85659C5.43642 30.4302 4.28516 29.279 4.28516 27.8588V4.71596ZM24.8566 4.71596H6.85659V27.8588H24.8566V4.71596Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobMatchesIcon);
export default __webpack_public_path__ + "static/media/jobMatchesIcon.654ba96a6770326cbef998c6b7f506bd.svg";
export { ForwardRef as ReactComponent };